<template>
  <button type="button" role="switch" class="ui-switch" :class="tone !== 'success' && `ui-switch--${tone}`" :aria-checked="String(value)" :aria-label="label" :title="title || label" :disabled="disabled" @click.stop="$emit('input', !value)"></button>
</template>

<script>
/** Prekidač (dugme sa ulogom switch). Klik ne otvara red u kojem stoji. Stanje drži roditelj: ovdje samo javlja novu vrijednost (v-model). */
export default {
  name: "UiSwitch",
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, required: true },
    title: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    /** boja uključenog prekidača: success (zelena) | accent (narandžasta) */
    tone: { type: String, default: "success" },
  },
};
</script>
